<template>
    <div class="bind-wrap">
        <div class="title">
            <div class="top">
                <img src="../../assets/loginlogo.png" alt class="img"/>
                <div style="margin-left: 15px">
                    <h2 class="large-title">智慧物联</h2>
                    <div class="small-title">共 享 物 联</div>
                </div>
            </div>
        </div>
        <div class="title">
            <Form>
                <Field
                        required
                        clearable
                        left-icon="phone-o"
                        placeholder="请输入绑定的手机号码"
                        v-model="phone"
                        :rules="[
                     {  required: true, message: '请输入手机号码' },
                     {  pattern : /^.{11}$/, message: '手机号码为11位' },
                    ]"
                />
                <Field
                        required
                        clearable
                        left-icon="comment-o"
                        placeholder="请输入验证码"
                        v-model="phoneCode"
                >
                    <Button slot="button" class="buttonsmall" size="small" type="info" @click="getUserCodeMobile()"
                            :disabled="disabled">
                <span v-if="sending == false">
                  发送验证码
                </span>
                        <span v-else>
                  {{second}}秒后重发
                </span>
                    </Button>
                </Field>
                <div :style="{'display':snp?'none':''}">
                    <Field
                            required
                            clearable
                            left-icon="goods-collect-o"
                            placeholder="请输入密码"
                            right-icon="closed-eye"
                            @click-right-icon="newshowPsw()"
                            v-model="newPassword"
                            type="password"
                            :rules="[
                             {  required: true, message: '请输入密码' },
                             {  pattern: /[0-9]/,message:'至少包含一个数字'},
                             {  pattern: /(?:.*?[!@#$%*()_+^&}{:;?.`])/,message:'至少包含一个特殊符号'},
                             {  pattern: /[a-z]/,message:'至少包含一个小写字母'}
                            ]"
                    />
                </div>
                <div :style="{'display':!snp?'none':''}">
                    <Field
                            required
                            clearable
                            left-icon="goods-collect-o"
                            placeholder="请输入密码"
                            right-icon="eye-o"
                            @click-right-icon="newhidePsw()"
                            v-model="newPassword"
                            :rules="[
                             {  required: true, message: '请输入密码' },
                             {  pattern: /[0-9]/,message:'至少包含一个数字'},
                             {  pattern: /(?:.*?[!@#$%*()_+^&}{:;?.`])/,message:'至少包含一个特殊符号'},
                             {  pattern: /[a-z]/,message:'至少包含一个小写字母'}
                            ]"
                    />
                </div>
                <div :style="{'display':sspcp?'none':''}">
                    <Field
                            required
                            clearable
                            left-icon="goods-collect-o"
                            placeholder="请再次输入密码"
                            right-icon="closed-eye"
                            @click-right-icon="sshowPsw()"
                            v-model="confirmPassword"
                            type="password"
                            :rules="[
                              {  required:true,message:'请输入密码'},
                              {  validator : validatorPassword, message: '两次密码不一致' }
                            ]"
                    />
                </div>
                <div :style="{'display':!sspcp?'none':''}">
                    <Field
                            required
                            clearable
                            left-icon="goods-collect-o"
                            placeholder="请再次输入密码"
                            right-icon="eye-o"
                            @click-right-icon="shidePsw()"
                            v-model="confirmPassword"
                            :rules="[
                              {  required:true,message:'请输入密码'},
                              {  validator : validatorPassword, message: '两次密码不一致' }
                            ]"
                    />
                </div>
                <Button type="info" style="width: 95% ; margin: 30px auto;" @click="getResetPasswordMobile" block>确认重置
                </Button>
                <div class="warp-button"><span @click="wrap">立即登录</span></div>
            </Form>
        </div>
    </div>
</template>

<script>
    import store from "@/store"
    import {isWechat} from "@/utils/tool"
    import {Button, Field, Form} from "vant";

    export default {
        components: {
            Field,
            Button, Form
        },
        props: {},
        data() {
            return {
                phone: null,
                newPassword: null,
                confirmPassword: null,
                phoneCode: null,
                mobileresult: null,
                isSend1: false,
                isSend2: false,
                isSend3: false,
                sending: false,
                disabled: false,
                second: 60,
                sspcp: false,
                snp: false
            };
        },
        computed: {},
        created() {
        },
        mounted() {
            console.error('登陆界面')
            store.dispatch({type: 'global/reset'})
        },
        methods: {
            validatorPassword(value) {
                const newPassword = this.newPassword;
                if (newPassword == value) {
                    return true;
                } else {
                    return false;
                }
            },
            sshowPsw() {
                this.sspcp = true;
            },
            shidePsw() {
                this.sspcp = false;
            },
            newshowPsw() {
                this.snp = true;
            },
            newhidePsw() {
                this.snp = false;
            },
            wrap() {
                this.$router.push("/account/bind/")
            },
            getUserCodeMobile() {
                if (this.phone == null || this.phone == "") {
                    this.$toast.fail("请输入手机号码");
                } else {
                    this.$http.tokiot.sys.user.codeMobile({phone: this.phone})
                        .then(res => {
                            if (res) {
                                this.$toast.success("验证码已经发送");
                                this.sending = true;
                                this.disabled = true;
                                this.timeDown();
                            } else {
                                this.$toast.fail(res.message)
                            }
                        })
                }
            },
            getResetPasswordMobile() {
                if (this.phone == null && this.newPassword == null) {
                    return this.$toast.fail("请完整填写");
                } else if (this.phone == null) {
                    return this.$toast.fail("请输入绑定的手机号码");
                } else if (this.phoneCode == null) {
                    return this.$toast.fail("请输入验证码");
                } else if (this.newPassword == null) {
                    return this.$toast.fail("请输入新密码");
                } else if (this.confirmPassword == null) {
                    return this.$toast.fail("请输入确认密码");
                } else if (this.newPassword.length < 8) {
                    return this.$toast.fail("请输入新密码 至少要8个字符。");
                } else if (/[0-9]/.test(this.newPassword) == false) {
                    return this.$toast.fail("至少包含一个数字");
                } else if (/[a-z]/.test(this.newPassword) == false) {
                    return this.$toast.fail("至少包含一个字母");
                } else if (
                    /(?:.*?[!@#$%*()_+^&}{:;?.`])/.test(this.newPassword) == false
                ) {
                    return this.$toast.fail("至少包含一个特殊符号");
                } else if (this.confirmPassword !== this.newPassword) {
                    return this.$toast.fail("两次密码不一致");
                }
                this.$toast.loading("正在处理中...")
                this.$http.tokiot.sys.user.resetPasswordMobile({
                    phoneCode: this.phoneCode,
                    password: this.newPassword
                }).then(res => {
                    if (res) {
                        this.$toast.success("重置成功");
                        setTimeout(() => {
                            this.$router.go(-1);
                        }, 1000);
                    } else {
                        this.$toast.fail(res.message);
                    }
                })
            },
            timeDown() {
                let result = setInterval(() => {
                    this.second--;
                    console.log("定时器", this.second);
                    if (this.second < 0) {
                        clearInterval(result);
                        this.sending = false;
                        this.disabled = false;
                        this.second = 60;
                    }
                }, 1000);
            }
        },
        watch: {
            phone() {
                this.isSend1 = true;
            },
            newPassword() {
                this.isSend2 = true;
            },
            confirmPassword() {
                this.isSend3 = true;
            }
        }
    };
</script>

<style lang="less" scoped>
    .bind-wrap {

        .title {
            padding-top: 8px;
        }

        .large-title {
            font-size: 30px;
            font-weight: 500
        }

        .small-title {
            font-size: 16px;
            margin-top: -15px
        }

        .img {
            width: 100px;
            height: 100px
        }

        .top {
            display: flex;
            flex-direction: row;
            padding-left: 10px;
            padding-bottom: 8px;
        }

        .warp-button {
            color: #1890ff;
            text-align: right;
            margin-right: 12px;
        }
    }
</style>
